export const base64Decode = (text: string) => atob(text)
